'use strict';

(function () {
  Drupal.behaviors.accordion = {
    attach: function (context) {
      const accordionContainers = once('accordion', '.accordion-container', context);
      accordionContainers.forEach(function(container) {
        // Find which items should be open on init
        const openOnInit = [];
        const items = container.querySelectorAll('.ac');
        items.forEach(function(item, index) {
          if (item.getAttribute('data-open-by-default') === 'true') {
            openOnInit.push(index);
          }
        });
        
        new Accordion(container, {
          duration: 500,
          showMultiple: true,
          openOnInit: openOnInit
        });
      });
    }
  };
})();
